// extracted by mini-css-extract-plugin
export default {"pokupki-settings":"pokupki-settings--c465b3","pokupkiSettings":"pokupki-settings--c465b3"};